import {
  LoanApplicationIdSchema,
  LoanCaseIdSchema,
  MetricsSchema,
  OfferIdSchema,
} from 'shared/schemas/common';
import * as v from 'valibot';

export const OfferSchema = v.object({
  id: OfferIdSchema,
  loan_offer_external_id: LoanApplicationIdSchema,
  loan_application_external_id: LoanCaseIdSchema,
  last_sync_at: v.nullish(v.string(), () => undefined),
  status: v.string(),
  debt_coverage_percentage: v.number(),
  nominal_interest_rate: v.number(),
  terms: v.number(),
  total_cost: v.number(),
  balance: v.number(),
  approved_amount: v.number(),
  approved_duration: v.number(),
  effective_interest_rate: v.number(),
  installment_charges: v.number(),
  monthly_payment: v.number(),
  signing_url: v.string(),
  bank_id: v.number(),
  bank_name: v.string(),
  tags: v.array(
    v.object({
      name: v.string(),
    }),
  ),
  metrics: v.nullish(MetricsSchema, () => undefined),
});

export type Offer = v.InferOutput<typeof OfferSchema>;

export const OffersStatusSchema = v.object({
  is_closed: v.boolean(),
  is_expired: v.boolean(),
  status: v.picklist(['IN_PROCESS', 'COMPLETED', 'MANUAL_HANDLING']),
  offers: v.array(OfferSchema),
  tags: v.array(
    v.object({
      name: v.string(),
    }),
  ),
  metrics: v.nullish(MetricsSchema, () => undefined),
});

export type OffersStatus = v.InferOutput<typeof OffersStatusSchema>;
